<template>
	<div class="add-role">
		<!-- 头部 -->
		<crm-header
			ref="header"
			:subTitle="subTitle"
			:hideBorder="false"
			:isGoback="true"
			:isAddBtn="false"
			:formData="formData"
		>
		</crm-header>
		<!-- 权限配置区域 -->
		<client-module class="promission-module" hideBorder>
			<div slot="moduletitle" class="promission-all">
				<span>权限选择：</span>
				<el-checkbox v-model="checkAll" @change="promissionAll">全选</el-checkbox>
			</div>

			<div class="promission-system" v-for="(item, name) in promissionData" :key="name">
				<div class="promission-system-title">
					<div class="promission-system-name">{{ systemInfo[name].name }}</div>
					<el-checkbox v-model="systemStatus[name]" @change="promissionSystemAll($event, name)"
						>全选</el-checkbox
					>
				</div>
				<promission-checkbox
					ref="promissionCheckbox"
					v-for="item in item"
					:key="item.id"
					:checkboxData="item"
					:checkAll="Boolean(item.selected)"
					@promission-change="promissionChange"
				></promission-checkbox>
			</div>
		</client-module>
		<!-- 保存功能区 -->
		<el-row type="flex" justify="end" class="submit">
			<el-button type="primary" @click="validate" :loading="btnLoading">保存</el-button>
		</el-row>
	</div>
</template>

<script>
import crmHeader from '@/components/personnelManage/crm-header';
import clientModule from '@/components/client/clientModule/clientModule.vue';
import promissionCheckbox from '@/client/pages/personnelManage/promissionCheckbox.vue';
import { validRequired, validMax, validCharacter } from '@/common/elementValid.js';
import { systemInfo } from '@/common/dictionary';
export default {
	name: 'add-role',
	components: {
		crmHeader,
		clientModule,
		promissionCheckbox,
	},
	props: {
		subTitle: {
			type: String,
			default: '添加适用于您公司的角色及角色相关的权限',
		},
		roleApi: {
			type: Object,
		},
		callback: {
			type: Function,
		},
	},
	data() {
		return {
			formData: {},
			title: '新增角色',
			promissionData: [],
			checkAll: false,
			btnLoading: false,
			systemStatus: {}, // 各系统的状态
			systemInfo, // 系统信息
			systemCode: {},
		};
	},
	computed: {
		isEdit() {
			return this.$route.query.edit;
		},
		roleId() {
			return this.$route.query.roleId;
		},
	},
	mounted() {
		this.requestData();
	},
	methods: {
		requestData() {
			this.setformData();
			this.queryMenuPermission();
		},
		// 获取权限详情
		async queryMenuPermission() {
			try {
				let roleId = this.$route.query.roleId;
				let dataCopy = {};
				const res = await this.roleApi.queryMenuPermission({
					roleId,
				});
				for (const key in res.data) {
					dataCopy[key] = res.data[key][0].operate;
					this.systemCode[key] = res.data[key][0].id;
				}
				this.addState(dataCopy);
				this.promissionData = dataCopy;
				this.judgeAll();
			} catch (e) {
				console.error(e);
			}
		},
		// 添加系统选择状态
		addState(obj) {
			let status = {};
			function filter(data, key) {
				status[key] = true;
				data.forEach(item => {
					if (!item.selected) status[key] = false;
					if (status[key] && item.operate && item.operate.length !== 0) {
						filter(item.operate, key);
					}
				});
			}
			for (const key in obj) {
				filter(obj[key], key);
			}
			this.systemStatus = status;
		},
		// 全选
		promissionAll(val) {
			function change(data) {
				data.forEach(item => {
					item.selected = Number(val);
					if (item.operate && item.operate.length !== 0) {
						change(item.operate, val);
					}
				});
			}
			for (const key in this.promissionData) {
				change(this.promissionData[key], val);
			}
			this.addState(this.promissionData);
		},
		//单个系统全选
		promissionSystemAll(val, name) {
			function change(data) {
				data.forEach(item => {
					item.selected = Number(val);
					if (item.operate && item.operate.length !== 0) {
						change(item.operate, val);
					}
				});
			}
			change(this.promissionData[name]);
			this.judgeAll();
		},
		// 一级权限
		promissionChange(val, id) {
			let { promissionData } = this;
			// 深度过滤
			let parentList = this.filterData(promissionData, id);
			// 修改对应层级数据
			this.updateData(parentList, Number(val));
			// 维护父级数据状态
			this.updateParent(promissionData);
			// 校验全选
			this.judgeAll();

			this.addState(promissionData);
		},
		judgeAll() {
			// 全选
			let filterArr = this.filterId(this.promissionData, 0);
			if (filterArr.length === 0) {
				this.checkAll = true;
			} else {
				this.checkAll = false;
			}
		},
		// 深度过滤
		filterData(data, val) {
			let arr = [];
			function filter(data, val) {
				data.forEach(item => {
					if (item.id === val) arr.push(item);
					if (item.operate && item.operate.length !== 0) {
						filter(item.operate, val);
					}
				});
			}
			for (const key in data) {
				filter(data[key], val);
			}
			return arr;
		},
		// 修改对应层级数据
		updateData(data, val) {
			data.forEach(item => {
				item.selected = val;
				if (item.operate && item.operate.length !== 0 && !val) {
					this.updateData(item.operate, val);
				}
			});
		},
		// 维护父级数据状态
		updateParent(data) {
			for (const key in data) {
				data[key].forEach(item => {
					if (item.operate && item.operate.length !== 0) {
						let filterArr = item.operate.filter(val => val.selected === 1);
						if (filterArr.length === 0) {
							// item.selected = 0;
						} else {
							item.selected = 1;
						}
					}
				});
			}
		},
		// 深度过滤
		filterId(data, status) {
			let arr = [];
			function filter(data, status) {
				data.forEach(item => {
					if (item.selected === status) arr.push(item.id);
					if (item.operate && item.operate.length !== 0) {
						filter(item.operate, status);
					}
				});
			}
			for (const key in data) {
				filter(data[key], status);
			}
			return arr;
		},
		// 必填
		validate() {
			this.$refs.header.validate(this.submit);
		},
		// 判断系统是否选择
		filterSystemId() {
			let unActive = [];
			let active = [];
			for (const key in this.promissionData) {
				let filterArr = this.promissionData[key].filter(val => val.selected === 1);
				if (filterArr.length === 0) {
					unActive.push(this.systemCode[key]);
				} else {
					active.push(this.systemCode[key]);
				}
			}
			return {
				unActive,
				active,
			};
		},
		// 保存
		async submit(val) {
			if (!val) {
				this.$message.info('请输入角色名称和描述');
				return false;
			}
			try {
				let { promissionData, formData, roleId, isEdit, roleApi, api, param } = this;
				let unActive = this.filterId(promissionData, 0);
				let active = this.filterId(promissionData, 1);
				let systemActive = this.filterSystemId();
				unActive = unActive.concat(systemActive.unActive);
				active = active.concat(systemActive.active);
				let name = formData.name.value;
				let desc = formData.desc.value;
				if (isEdit) {
					api = roleApi['editRole'];
					param = {
						name,
						desc,
						id: roleId,
						cancelMenuIds: unActive,
						menuIds: active,
					};
				} else {
					api = roleApi['addRole'];
					param = {
						name,
						desc,
						menuIds: active,
					};
				}

				this.btnLoading = true;
				await api(param);

				this.btnLoading = false;
				sessionStorage.setItem(
					'row',
					JSON.stringify({
						name,
						desc,
					})
				);
				this.requestData();
				this.$router.go(-1);
				this.$message.success('操作成功');
			} catch (error) {
				this.btnLoading = false;
				this.$message.warning('操作失败');
			}
		},
		// 表单配置项
		setformData() {
			let val = JSON.parse(sessionStorage.getItem('row'));
			let name, desc;
			if (this.isEdit && val) {
				name = val.name;
				desc = val.desc;
			}
			this.formData = {
				name: {
					label: '角色名称',
					formType: 'sky-input',
					value: name || '',
					placeholder: '请输入角色名称',
					col: 6,
					rules: [validRequired('请输入角色名称', 'blur'), validMax(50), validCharacter()],
				},
				desc: {
					label: '角色描述',
					formType: 'sky-input',
					placeholder: '请输入角色描述',
					value: desc || '',
					col: 7,
					colStyle: {
						marginLeft: '50px',
					},
					rules: [validMax(50)],
				},
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.add-role {
	padding: 0 20px;

	.submit {
		margin-top: 10px;
	}

	.promission-module {
		::v-deep  .module-top {
			background-color: #fff;
			box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
			border-radius: 10px;
		}

		.promission-system {
			margin-top: 15px;
			background-color: #fff;
			box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
			border-radius: 10px;

			.promission-system-title {
				height: 59px;
				line-height: 59px;

				.promission-system-name {
					height: 100%;
					float: left;
					padding-left: 20px;
					font-size: 18px;
					font-weight: 700;
					color: rgba(0, 0, 0, 0.85);
				}

				.el-checkbox {
					margin-right: 45px;
					float: right;
				}
			}
		}
	}
}
</style>
